import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";

const ADMIN_EMAIL = "admin@milkath.com";

/**
 * Renders children only for the platform administrator
 * (email === admin@milkath.com). Anyone else gets a 403 redirect.
 */
export default function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user || (user.email || "").toLowerCase() !== ADMIN_EMAIL) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
}
